export default "__VITE_ASSET__19a6dbf6__"